import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import NotarySection from 'modules/_shared/components/NotarySection';
import InputTextArea from 'modules/_shared/components/InputTextArea';
import InputDate from 'modules/_shared/components/InputDate';
import { useUpdateOperationModal } from '../context/UpdateOperationModalContext';

const UpdateOperationModalBody: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useUpdateOperationModal();

  return (
    <Modal.Body>
      <InputDate
        id="date"
        label={t('Date')}
        value={data.date || ''}
        errorMessageKey="InvalidOperationDate"
        readOnly
        lgSize
      />

      <InputTextArea
        id="comments"
        label={t('CommentsLabel')}
        value={data.comments}
        onChange={actions.handleChangeComments}
        noResize
      />

      {data.hasNotarialRegistration && (
        <div className="row mb-4">
          <NotarySection
            notaryName={data.notaryName}
            onChangeName={actions.handleChangeNotaryName}
            notaryProtocol={data.notaryProtocol}
            onChangeProtocol={actions.handleChangeNotaryProtocol}
            notaryCity={data.notaryCity}
            onChangeCity={actions.handleChangeNotaryCity}
            lgSize
          />
        </div>
      )}
    </Modal.Body>
  );
};

export default UpdateOperationModalBody;
